import { createContext, useContext } from "react";

import type { SelectProps } from "./Select.types";

export type SelectContextValue = Pick<
  SelectProps,
  "size" | "layout" | "effect"
> & {
  leftInset: number;
  onLeftInsetChange: (inset: number) => void;
  clearable: boolean;
  hasValue: boolean;
  clear: () => void;
};

export function makeSelectContext({
  size = "md",
  layout = "default",
  effect = "press",
  leftInset = 0,
  onLeftInsetChange = () => {},
  clearable = false,
  hasValue = false,
  clear = () => {},
}: Partial<SelectContextValue>): Required<SelectContextValue> {
  return {
    size,
    layout,
    effect,
    leftInset,
    onLeftInsetChange,
    clearable,
    hasValue,
    clear,
  };
}

export const SelectContext = createContext<Required<SelectContextValue>>(
  makeSelectContext({}),
);

export function useSelectContext() {
  return useContext(SelectContext);
}
